import { render } from "./RecordAudioSetting.vue?vue&type=template&id=6d107f0b"
import script from "./RecordAudioSetting.vue?vue&type=script&lang=js"
export * from "./RecordAudioSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__